import script from "./TodoNavbarSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./TodoNavbarSettings.vue?vue&type=script&setup=true&lang=ts"

import "./TodoNavbarSettings.vue?vue&type=style&index=0&id=0ee46b6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ee46b6e"]])

export default __exports__